import ResponseCode from "../ResponseCode";
import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const buscarPrecertificacionUrl =
  "api/v1/websalud/primeraars/precertificaciones/reporte";

const consultarReportes = async (request) => {
  const parametros = {
    fechaDesde: request?.fechaDesde,
    fechaHasta: request?.fechaHasta,
    estatus: request?.estatus,
    tipoReclamante: request?.codigoPss ? request?.tipoPss : "",
    codigoReclamante: request?.codigoPss,
    compania: request?.compania,
    numeroPagina: request?.pagina || 1,
    tamanoPagina: request?.registrosPorPagina || 10,
    asegurado: request?.tipoBusqueda === "asegurado" ? request?.buscar : "",
    numeroSolicitud:
      request?.tipoBusqueda === "numeroSolicitud" ? request?.buscar : "",
    numeroAutorizacion:
      request?.tipoBusqueda === "numeroAutorizacion" ? request?.buscar : ""
  };

  const response = await InterceptToken(
    BaseApi.get,
    buscarPrecertificacionUrl,
    parametros
  );
  return response.data;
};

const exportarReportes = async (request) => {
  const parametros = {
    fechaDesde: request?.fechaDesde,
    fechaHasta: request?.fechaHasta,
    estatus: request?.estatus,
    tipoReclamante: request?.codigoPss ? request?.tipoPss : "",
    codigoReclamante: request?.codigoPss,
    compania: request?.compania,
    asegurado: request?.tipoBusqueda === "asegurado" ? request?.buscar : "",
    numeroSolicitud:
      request?.tipoBusqueda === "numeroSolicitud" ? request?.buscar : "",
    numeroAutorizacion:
      request?.tipoBusqueda === "numeroAutorizacion" ? request?.buscar : ""
  };

  const response = await InterceptToken(
    BaseApi.get,
    `${buscarPrecertificacionUrl}/exportar/${request.tipo}`,
    parametros,
    { responseType: "blob" }
  );
  return response;
};

const exportedObject = {
  consultarReportes,
  exportarReportes
};

export default exportedObject;
